// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pn-T","name":"styles_name__6qXbY","phone":"styles_phone__22CEw"};